import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaHeartbeat, FaNotesMedical, FaStethoscope, FaCalendarCheck, FaBriefcaseMedical, FaHospital, FaClinicMedical, FaProcedures, FaAmbulance, FaUserNurse } from "react-icons/fa";
import Medpalm from "../../../assests/Healthcareprovider/Hospital.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Emergency & Trauma Care",
        "description": "Delivers 24/7 emergency medical response, advanced trauma care, and critical life-saving interventions for severe medical conditions such as heart attacks, strokes, major injuries, and respiratory failure. Equipped with state-of-the-art emergency rooms, rapid-response ambulance services, and highly skilled trauma teams, we ensure immediate stabilization, expert diagnosis, and urgent treatment. Our facilities include advanced life support systems, trauma resuscitation units, and dedicated intensive care teams to handle complex emergencies with precision and efficiency."
    },
    {
        "title": "Inpatient & Outpatient Services",
        "description": "Provides a comprehensive range of healthcare services, from extended hospital stays for patients requiring intensive monitoring to outpatient consultations for routine check-ups, post-treatment follow-ups, and specialized care. Our inpatient facilities offer advanced patient monitoring, personalized treatment plans, and coordinated medical care to promote recovery. Outpatient services include diagnostics, minor procedures, chronic disease management, and specialist consultations, ensuring seamless transitions between hospital-based and home-based care for optimal patient outcomes."
    },
    {
        "title": "Surgical Procedures",
        "description": "Performs a wide range of elective, emergency, and minimally invasive surgical procedures using cutting-edge medical technology. Our surgical expertise covers general surgery, orthopedic operations, cardiovascular interventions, neurosurgery, gastrointestinal procedures, and robotic-assisted surgeries for enhanced precision and faster recovery. Each surgery is supported by pre-operative planning, real-time intraoperative monitoring, and post-surgical rehabilitation to optimize patient safety, minimize complications, and improve recovery outcomes."
    },
    {
        "title": "Diagnostic & Laboratory Services",
        "description": "Offers a full spectrum of diagnostic services, including advanced imaging (X-rays, MRIs, CT scans, ultrasounds, PET scans) and laboratory testing (blood analysis, biopsies, genetic screening, microbiology). Our high-tech diagnostic centers ensure rapid, accurate results to facilitate early disease detection, treatment planning, and continuous health monitoring. We employ AI-driven diagnostic tools and tele-radiology services to enhance accuracy and efficiency, enabling healthcare providers to make informed medical decisions with confidence."
    },
    {
        "title": "Specialty Care Clinics",
        "description": "Provides expert medical consultation and treatment across a wide range of specialties, including cardiology, neurology, oncology, pediatrics, dermatology, endocrinology, rheumatology, and more. Our specialized clinics integrate the latest advancements in medical research, diagnostic precision, and personalized treatment strategies to manage complex and chronic conditions. Multidisciplinary teams collaborate to deliver individualized care, ensuring that patients receive comprehensive evaluations, targeted therapies, and long-term disease management plans."
    },
    {
        "title": "Telehealth & Virtual Care",
        "description": "Empowers patients with convenient access to healthcare through secure, virtual consultations, remote monitoring, and digital health services. Our telehealth solutions enable real-time video calls, secure messaging, and virtual follow-ups for chronic disease management, post-surgical care, mental health support, and routine medical concerns. With AI-driven symptom checkers, digital prescriptions, and integrated electronic health records (EHR), we ensure continuous, high-quality care while reducing the need for in-person hospital visits, enhancing accessibility, and improving patient engagement."
    }
]

const features = [
    { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "State-of-the-art medical facilities with advanced equipment." },
    { icon: <FaClinicMedical className="text-[#2a627a] text-lg" />, text: "Specialized outpatient clinics for targeted treatments." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Highly skilled physicians, surgeons, and medical staff." },
    { icon: <FaAmbulance className="text-[#2a627a] text-lg" />, text: "Emergency response and ambulance services available 24/7." },
    { icon: <FaProcedures className="text-[#2a627a] text-lg" />, text: "Comprehensive inpatient care with modern hospital infrastructure." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Electronic Health Records (EHR) integration for seamless data management." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Ensures timely diagnosis and treatment for various health conditions." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Improves patient care with accurate medical record management." },
    { icon: <FaCalendarCheck className="text-[#2a627a] text-lg" />, text: "Offers scheduled and walk-in consultations for patient convenience." },
    { icon: <FaUserNurse className="text-[#2a627a] text-lg" />, text: "Provides specialized nursing care for inpatients and outpatients." },
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Enhances preventive healthcare through routine check-ups and screenings." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Reduces healthcare costs by enabling early intervention and management." }
];
const cmsFeatures = [
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Physicians & Specialists – Diagnose, treat, and manage patient health." },
    { icon: <FaUserNurse className="text-[#2a627a] text-lg" />, text: "Nurses – Provide critical care, patient monitoring, and support services." },
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Surgeons – Perform life-saving and elective surgeries." },
    { icon: <FaClinicMedical className="text-[#2a627a] text-lg" />, text: "Medical Technologists – Conduct lab tests and diagnostic procedures." },
    { icon: <FaAmbulance className="text-[#2a627a] text-lg" />, text: "Emergency Responders – Deliver urgent pre-hospital medical care." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Hospital Administrators – Manage operations, staff, and healthcare services." }
];

const Hospitalclinics = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Hospitals & Clinics  - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Enhancing healthcare through innovation, efficiency, and patient-centered solutions."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What are  Hospitals & Clinics?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Hospitals and clinics are essential healthcare providers, offering medical treatment, emergency care, and preventive services. Hospitals provide comprehensive inpatient care, while clinics focus on outpatient treatments and routine check-ups.

                            At HIKEHEALTH GS, we empower hospitals and clinics with advanced digital health solutions to enhance care, optimize operations, and ensure seamless healthcare delivery.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Hospitals & Clinics
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Hospitalclinics;
